import * as _ from "lodash";
import * as log from "loglevel";

export interface IQueryData{
	take?: number;
	skip?: number;
	where?: any;
	order?: IQueryOrder;
	surveyId?: string;
	userId?: string;
	appId?: string;
}

export interface IQueryOrder{
	direction: string;
	field: string;
}

export class QueryString{
	private queryStr = "";

	constructor(query: IQueryData){
		if(query.take){
			this.queryStr += `take=${query.take}&`;
		}

		if(query.skip){
			this.queryStr += `skip=${query.skip}&`;
		}

		if(query.order){
			this.queryStr += `order[${query.order.field}]=${query.order.direction.toUpperCase()}&`;
		}

		if(query.where){
			_.keys(query.where).forEach(key => {
				this.queryStr += `where[${key}]=${query.where[key]}&`;
			});
		}

		if(query.surveyId){
			this.queryStr += `surveyId=${query.surveyId}&`;
		}

		if(query.userId){
			this.queryStr += `userId=${query.userId}&`;
		}

		if(query.appId){
			this.queryStr += `appId=${query.appId}&`;
		}
	}

	get query(): string{
		return this.queryStr;
	}
}



// WEBPACK FOOTER //
// ./src/services/query.ts